import { ajax } from 'rxjs/ajax'
import { retry } from 'rxjs/operators'
import envGet from 'Support/Env/Get/EnvGet.support'
import { ServiceHeadersContentTypeJson } from 'Constants/Service/json-headers'

const BASE_URL_FLITCH = envGet({ key: `REACT_APP_BORAL_BASE_URL_FLITCH` }) as string
const UPDATE_ORDER_URL = envGet({ key: `REACT_APP_BORAL_UPDATE_ORDER_URL` }) as string

interface Options {
  payload: UpdateOrderServicePayload,
  orderKey: string,
  authHeaders?: any,
}
/*
  null if that field does not change
*/
export interface UpdateOrderServicePayload {
  dateTime: null | {
    offset: number,
    details: {
      year: number,
      month: number,
      day: number,
      hour: number,
      minute: number,
    }
  },
  instructions: string | null,
  quantity: number | null,
  siteContactPhoneNumber: string | null,
}

const updateOrderService = async (options: Options) => {
  const {
    payload,
    orderKey,
    authHeaders = {},
  } = options
  const headers = {
    ...authHeaders,
    ...ServiceHeadersContentTypeJson,
  }
  const body = payload
  const url = `${BASE_URL_FLITCH}${UPDATE_ORDER_URL.replace(`ORDER_KEY`, orderKey)}`

  return ajax({
    body,
    headers,
    method: `PUT`,
    url,
  })
    .pipe(retry(1))
    .toPromise()
}

export default updateOrderService
